import moment from "moment";
import {
  DATE_FORMAT,
  FREE_KIT_DATE,
  isFirstSessonIsToday,
} from "./commonMethods";

export const SELECT_TERM_OPTIONS = [
  { text: "This Term", value: "this" },
  { text: "Next Term", value: "next" },
];

export const CHILD_FIELDS = {
  childFirstName: "",
  childLastName: "",
  size: "",
  quantity: "1",
  gender: "Male",
  childDOB: "",
  photoVideoPermission: "yes",
  medicalConditionDetails: "",
  merchandise: "yes",
  childClassIds: [],
  attendedQuest: "no",
};

// Custom styling can be passed as options when creating an Element.
const AU_BANK_ACCOUNT_STYLE = {
  base: {
    color: "#32325d",
    fontSize: "16px",
    "::placeholder": {
      color: "#aab7c4",
    },
    ":-webkit-autofill": {
      color: "#32325d",
    },
  },
  invalid: {
    color: "#fa755a",
    iconColor: "#fa755a",
    ":-webkit-autofill": {
      color: "#fa755a",
    },
  },
};

export const AU_BANK_ACCOUNT_ELEMENT_OPTIONS = {
  style: AU_BANK_ACCOUNT_STYLE,
  disabled: false,
  hideIcon: false,
  iconStyle: "default", // or "solid"
};

export const parseSessionNames = ({ values, classes, term }) => {
  let sessions = [];
  let dateString = "";
  const today = moment(new Date()).format(DATE_FORMAT);

  for (let clssId of values?.classId) {
    for (let cls of classes) {
      if (cls._id === clssId?.value) {
        if (values?.paymentOption === "full") {
          for (let lesson of cls?.lessons) {
            if (
              isFirstSessonIsToday({
                startTime: lesson.startTime,
                enrolmentDate: today,
              })
                ? moment(lesson?.date, DATE_FORMAT).isSameOrAfter(
                  moment(today, DATE_FORMAT)
                )
                : moment(lesson?.date, DATE_FORMAT).isAfter(
                  moment(today, DATE_FORMAT)
                )
            ) {
              sessions.push(lesson);
            }
          }
        } else if (values?.paymentOption === "term") {
          for (let lesson of cls.lessons) {
            if (
              isFirstSessonIsToday({
                startTime: lesson.startTime,
                enrolmentDate: today,
              })
                ? moment(lesson?.date, DATE_FORMAT).isSameOrAfter(
                  moment(today, DATE_FORMAT)
                ) &&
                moment(lesson?.date, DATE_FORMAT).isSameOrBefore(
                  moment(term?.endDate, DATE_FORMAT)
                )
                : moment(lesson?.date, DATE_FORMAT).isAfter(
                  moment(today, DATE_FORMAT)
                ) &&
                moment(lesson?.date, DATE_FORMAT).isSameOrBefore(
                  moment(term?.endDate, DATE_FORMAT)
                )
            ) {
              sessions.push(lesson);
            }
          }
        }
      }
    }
  }

  sessions = sessions
    ?.filter((lesson) => !lesson.makeUpLesson)
    ?.sort((a, b) => moment(a.date, DATE_FORMAT) - moment(b.date, DATE_FORMAT));

  for (let session of sessions) {
    if (dateString.length === 0) {
      dateString += session.date;
    } else {
      dateString += ", " + session.date;
    }
  }

  return dateString;
};

export const parseLessonsNames = ({
  classId,
  classes,
  term,
  paymentOption,
  nextTerm,
  terms,
}) => {
  let sessions = [];
  let dateString = "";
  const today = moment(new Date()).format(DATE_FORMAT);
  // const today = "01/06/2021";

  const selectedClass = classes?.find((cls) => cls?._id === classId);

  const lastTerm = terms?.find((term) => term?.name === "Term 4");

  for (let cls of classes) {
    if (cls._id === classId) {
      if (!paymentOption || selectedClass?.paymentType === "free") {
        for (let lesson of cls?.lessons) {
          if (
            isFirstSessonIsToday({
              startTime: lesson.startTime,
              enrolmentDate: today,
            })
              ? moment(lesson?.date, DATE_FORMAT).isSameOrAfter(
                moment(today, DATE_FORMAT)
              ) &&
              moment(lesson.date, DATE_FORMAT).isSameOrBefore(
                moment(lastTerm?.endDate, DATE_FORMAT)
              )
              : moment(lesson?.date, DATE_FORMAT).isAfter(
                moment(today, DATE_FORMAT)
              ) &&
              moment(lesson.date, DATE_FORMAT).isSameOrBefore(
                moment(lastTerm?.endDate, DATE_FORMAT)
              )
          ) {
            sessions.push(lesson);
          }
        }
      } else if (paymentOption === "full") {
        if (nextTerm) {
          for (let lesson of cls?.lessons) {
            if (
              isFirstSessonIsToday({
                startTime: lesson.startTime,
                enrolmentDate: term?.startDate,
              })
                ? moment(lesson?.date, DATE_FORMAT).isSameOrAfter(
                  moment(term?.startDate, DATE_FORMAT)
                ) &&
                moment(lesson.date, DATE_FORMAT).isSameOrBefore(
                  moment(lastTerm?.endDate, DATE_FORMAT)
                )
                : moment(lesson?.date, DATE_FORMAT).isAfter(
                  moment(term?.startDate, DATE_FORMAT)
                ) &&
                moment(lesson.date, DATE_FORMAT).isSameOrBefore(
                  moment(lastTerm?.endDate, DATE_FORMAT)
                )
            ) {
              sessions.push(lesson);
            }
          }
        } else {
          for (let lesson of cls?.lessons) {
            // alert(
            //   isFirstSessonIsToday({
            //     startTime: lesson.startTime,
            //     enrolmentDate: today,
            //   })
            // );
            console.log(lastTerm?.endDate);
            console.log(lesson?.date);
            console.log(
              moment(lesson.date, DATE_FORMAT).isSameOrBefore(
                moment(lastTerm?.endDate, DATE_FORMAT)
              )
            );
            if (
              selectedClass?.repeat === "no"
                ? isFirstSessonIsToday({
                  startTime: lesson.startTime,
                  enrolmentDate: today,
                })
                  ? moment(lesson?.date, DATE_FORMAT).isSameOrAfter(
                    moment(today, DATE_FORMAT)
                  )
                  : moment(lesson?.date, DATE_FORMAT).isAfter(
                    moment(today, DATE_FORMAT)
                  )
                : isFirstSessonIsToday({
                  startTime: lesson.startTime,
                  enrolmentDate: today,
                })
                  ? moment(lesson?.date, DATE_FORMAT).isSameOrAfter(
                    moment(today, DATE_FORMAT)
                  ) &&
                  moment(lesson.date, DATE_FORMAT).isSameOrBefore(
                    moment(lastTerm?.endDate, DATE_FORMAT)
                  )
                  : moment(lesson?.date, DATE_FORMAT).isAfter(
                    moment(today, DATE_FORMAT)
                  ) &&
                  moment(lesson.date, DATE_FORMAT).isSameOrBefore(
                    moment(lastTerm?.endDate, DATE_FORMAT)
                  )
            ) {
              sessions.push(lesson);
            }
          }
        }
      } else if (paymentOption === "monthly") {
        const currentMonthSunday = currentMonthFirstSundayHelper(today);
        let nextDueDate;
        if (
          moment(today, DATE_FORMAT).isBefore(
            moment(currentMonthSunday, DATE_FORMAT)
          )
        ) {
          nextDueDate = currentMonthSunday;
        } else {
          nextDueDate = nextMonthFirstSundayHelper(today);
        }

        for (let lesson of cls?.lessons) {
          if (
            isFirstSessonIsToday({
              startTime: lesson.startTime,
              enrolmentDate: today,
            })
              ? moment(lesson?.date, DATE_FORMAT).isSameOrAfter(
                moment(today, DATE_FORMAT)
              ) &&
              moment(lesson.date, DATE_FORMAT).isSameOrBefore(
                moment(nextDueDate, DATE_FORMAT)
              )
              : moment(lesson?.date, DATE_FORMAT).isAfter(
                moment(today, DATE_FORMAT)
              ) &&
              moment(lesson.date, DATE_FORMAT).isSameOrBefore(
                moment(nextDueDate, DATE_FORMAT)
              )
          ) {
            sessions.push(lesson);
          }
        }
      } else if (paymentOption === "term") {
        for (let lesson of cls.lessons) {
          if (nextTerm) {
            if (
              isFirstSessonIsToday({
                startTime: lesson.startTime,
                enrolmentDate: term?.startDate,
              })
                ? moment(lesson?.date, DATE_FORMAT).isSameOrAfter(
                  moment(term?.startDate, DATE_FORMAT)
                ) &&
                moment(lesson?.date, DATE_FORMAT).isSameOrBefore(
                  moment(term?.endDate, DATE_FORMAT)
                )
                : moment(lesson?.date, DATE_FORMAT).isAfter(
                  moment(term?.startDate, DATE_FORMAT)
                ) &&
                moment(lesson?.date, DATE_FORMAT).isSameOrBefore(
                  moment(term?.endDate, DATE_FORMAT)
                )
            ) {
              sessions.push(lesson);
            }
          } else {
            if (
              isFirstSessonIsToday({
                startTime: lesson.startTime,
                enrolmentDate: today,
              })
                ? moment(lesson?.date, DATE_FORMAT).isSameOrAfter(
                  moment(today, DATE_FORMAT)
                ) &&
                moment(lesson?.date, DATE_FORMAT).isSameOrBefore(
                  moment(term?.endDate, DATE_FORMAT)
                )
                : moment(lesson?.date, DATE_FORMAT).isAfter(
                  moment(today, DATE_FORMAT)
                ) &&
                moment(lesson?.date, DATE_FORMAT).isSameOrBefore(
                  moment(term?.endDate, DATE_FORMAT)
                )
            ) {
              sessions.push(lesson);
            }
          }
        }
      }
    }
  }

  sessions = sessions
    ?.filter((lesson) => !lesson?.makeUpLesson)
    ?.sort(
      (a, b) => moment(a?.date, DATE_FORMAT) - moment(b?.date, DATE_FORMAT)
    );

  for (let session of sessions) {
    if (dateString?.length === 0) {
      dateString += session?.date;
    } else {
      dateString += ", " + session?.date;
    }
  }

  return { dateString, sessions };
};

export const parseLessonsNamesHelper = ({ sessions, allLessons }) => {
  const lessons = allLessons.filter((lesson) => sessions?.includes(lesson._id));
  const sortedSessions = lessons
    ?.filter((session) => !session.makeUpLesson)
    .sort((a, b) => moment(a.date, DATE_FORMAT) - moment(b.date, DATE_FORMAT));

  let dateString = "";

  for (let session of sortedSessions) {
    if (dateString.length === 0) {
      dateString += session.date;
    } else {
      dateString += ", " + session.date;
    }
  }

  return dateString;
};

export const currentMonthFirstSundayHelper = (currentDate) => {
  const today = moment(currentDate, DATE_FORMAT).add(1, "M");
  const month = today.month();
  const year = today.year();

  const firstSunday = moment(`07/${month}/${year}`, DATE_FORMAT)
    .startOf("week")
    .day("Sunday")
    .format(DATE_FORMAT);

  return firstSunday;
};

export const nextMonthFirstSundayHelper = (currentDate) => {
  const today = moment(currentDate, DATE_FORMAT).add(1, "M");
  const month = moment(today, DATE_FORMAT).month() + 1;
  const year = moment(today, DATE_FORMAT).year();

  const firstSunday = moment(`07/${month}/${year}`, DATE_FORMAT)
    .startOf("week")
    .day("Sunday")
    .format(DATE_FORMAT);

  return firstSunday;
};

export const getLessonsOptions = (
  classes,
  classId,
  paymentOption,
  enrolmentDate,
  term,
  terms
) => {
  console.log({ classes,
    classId,
    paymentOption,
    enrolmentDate,
    term,
    terms})
  if (classes && classes.length && classId) {
    const lastTerm = terms?.find((term) => term?.name === "Term 4");
    const index = classes?.findIndex((cls) => cls._id === classId);
    if (index < 0){
      return [];
    }
    const selectedClass = classes[index];
    const enrolledDate = moment(enrolmentDate, "YYYY-MM-DD").format(
      DATE_FORMAT
    );

    let lessons = [];
    if (paymentOption && paymentOption !== "full" && enrolmentDate) {
      if (paymentOption === "full") {
        lessons = selectedClass?.lessons
          ?.filter((lesson) =>
            moment(lesson.date, DATE_FORMAT).isAfter(
              moment(enrolledDate, DATE_FORMAT)
            )
          )
          .filter((lesson) =>
            moment(lesson?.date, DATE_FORMAT).isSameOrBefore(
              moment(lastTerm?.endDate, DATE_FORMAT)
            )
          );
      } else if (paymentOption === "monthly") {
        const currentMonthSunday = currentMonthFirstSundayHelper(enrolledDate);
        let nextDueDate;
        if (
          moment(enrolledDate, DATE_FORMAT).isBefore(
            moment(currentMonthSunday, DATE_FORMAT)
          )
        ) {
          nextDueDate = currentMonthSunday;
        } else {
          nextDueDate = nextMonthFirstSundayHelper(enrolledDate);
        }

        lessons = selectedClass?.lessons
          ?.filter((lesson) =>
            isFirstSessonIsToday({
              startTime: lesson.startTime,
              enrolmentDate: enrolledDate,
            })
              ? moment(lesson.date, DATE_FORMAT).isSameOrAfter(
                moment(enrolledDate, DATE_FORMAT)
              )
              : moment(lesson.date, DATE_FORMAT).isAfter(
                moment(enrolledDate, DATE_FORMAT)
              )
          )
          ?.filter((lesson) =>
            moment(lesson.date, DATE_FORMAT).isSameOrBefore(
              moment(nextDueDate, DATE_FORMAT)
            )
          );
      } else if (paymentOption === "term") {
        lessons = selectedClass?.lessons
          ?.filter((lesson) =>
            isFirstSessonIsToday({
              startTime: lesson.startTime,
              enrolmentDate: enrolledDate,
            })
              ? moment(lesson.date, DATE_FORMAT).isSameOrAfter(
                moment(enrolledDate, DATE_FORMAT)
              )
              : moment(lesson.date, DATE_FORMAT).isAfter(
                moment(enrolledDate, DATE_FORMAT)
              )
          )
          ?.filter((lesson) =>
            moment(lesson.date, DATE_FORMAT).isSameOrBefore(
              moment(term?.endDate, DATE_FORMAT)
            )
          );
      }
    } else {
      lessons = selectedClass?.lessons
        ?.filter((lesson) =>
          isFirstSessonIsToday({
            startTime: lesson.startTime,
            enrolmentDate: enrolledDate,
          })
            ? moment(lesson.date, DATE_FORMAT).isSameOrAfter(
              moment(enrolledDate, DATE_FORMAT)
            )
            : moment(lesson.date, DATE_FORMAT).isAfter(
              moment(enrolledDate, DATE_FORMAT)
            )
        )
        .filter((lesson) =>
          moment(lesson?.date, DATE_FORMAT).isSameOrBefore(
            moment(lastTerm?.endDate, DATE_FORMAT)
          )
        );
    }

    const options = lessons
      ?.filter((lesson) => !lesson?.makeUpLesson)
      ?.sort(
        (a, b) => moment(a.date, DATE_FORMAT) - moment(b.date, DATE_FORMAT)
      )
      ?.map((lesson) => ({
        label: `${lesson?.date} - ${lesson?.venue
          ? lesson?.venue?.name
          : lesson?.location
            ? lesson?.location?.name
            : null
          }`,
        value: lesson?._id,
      }));

      console.log("options", options)
    return options;
  } else{
    return []
  }
};

export const selectedClassHelper = ({ classId, classes }) => {
  let selectedClass = {};
  if (Array.isArray(classes) && classId) {
    const index = classes?.findIndex((cls) => cls?._id === classId);

    selectedClass = classes[index];
  }

  return {
    ...selectedClass,
    payment: selectedClass?.payment
      ?.filter((option) => option)
      .filter((option) => option?.length > 1),
  };
};

export const isClassFullHelper = (cls) => {
  let isFull = false;
  if (cls.activeCancelPendingEnrolments && cls.activeCancelPendingEnrolments !== undefined) {
    if (
      cls?.service?.capacity_check &&
      cls?.capacity &&
      cls?.activeCancelPendingEnrolments &&
      Array.isArray(cls?.activeCancelPendingEnrolments) &&
      parseInt(cls?.capacity) <= cls?.activeCancelPendingEnrolments?.length
    ) {
      isFull = true;
    } else {
      isFull = false;
    }
  } else {
    if (
      cls?.service?.capacity_check &&
      cls?.capacity &&
      cls?.students &&
      Array.isArray(cls?.students) &&
      parseInt(cls?.capacity) <= cls?.students?.length
    ) {
      isFull = true;
    } else {
      isFull = false;
    }
  }
 

  return isFull;
};

export const priceCalculateHelper = ({
  selectedClass,
  values,
  selectedCoupon,
  lessons,
}) => {
  const { paymentOption, childs, studentIds } = values;

  const studentWithOrderInfo = childs
    .filter(
      (child) =>
        child.attendedQuest === "no" &&
        parseInt(child.size) > 0 &&
        parseInt(child.quantity) > 0
    )
    .filter(
      (child) =>
        child.merchandise === "yes" &&
        parseInt(child.size) > 0 &&
        parseInt(child.quantity) > 0
    );

  const product = selectedClass?.product;
  console.log("~~~~~~~~~~~", product)
  const enrolmentDate = moment(new Date()).format(DATE_FORMAT);

  const selectedLessons = selectedClass?.lessons?.filter((lesson) =>
    lessons?.includes(lesson._id)
  );

  let classCalculatedAmount =
    selectedLessons?.filter((lesson) => !lesson?.makeUpLesson)?.length *
    parseFloat(selectedClass.unit_price);

  let matchDayAmount =
    selectedLessons?.filter((lesson) => lesson?.matchDay)?.length *
    parseFloat(selectedClass.unit_price);

  let totalMatchDayAmount = 0;

  // let totalStudents = childs.length;
  const existingStudents = studentIds ? studentIds : [];
  const allStudents = [
    ...childs,
    ...existingStudents.map((student) => ({
      student,
      existingStudent: true,
    })),
  ];

  let count = selectedClass?.students?.length;
  const childsData = allStudents?.map((child, index) => {
    return {
      ...child,
      isClassFull: !selectedClass?.service?.capacity_check
        ? false
        : parseInt(selectedClass.capacity) <= count + index
          ? true
          : false,
      additionalChildDiscount:
        index > 0 ? selectedClass.additional_child_discount : 0,
      totalAmount: classCalculatedAmount,
      matchDayAmount,
    };
  });

  let totalAmountToPay = 0;

  //Applying additional User discount
  const applyAdditionalChildDiscount = childsData.map((data) => {
    return {
      ...data,
      amountAfterAdditionalDiscount:
        parseFloat(data.additionalChildDiscount) > 0
          ? data.totalAmount *
          (1 - parseFloat(data.additionalChildDiscount).toFixed(2) / 100)
          : data.totalAmount,
    };
  });

  //Multiplying with number of students
  //Additional Child Discount
  for (let child of applyAdditionalChildDiscount) {
    if (!child.isClassFull) {
      totalAmountToPay += child.amountAfterAdditionalDiscount;
      totalMatchDayAmount += child.matchDayAmount;
    }
  }

  const classPrice = totalAmountToPay;

  //Calculating Order Amount
  let orderAmount = 0;

  if (studentWithOrderInfo.length > 0) {
    for (let studentWithOrder of studentWithOrderInfo) {
      orderAmount +=
        parseFloat(product?.price) * parseInt(studentWithOrder.quantity);
    }
  }

  //Applying free kit till 31st of March
  if (
    (!selectedClass.kitMandatory &&
      paymentOption === "full" &&
      product &&
      parseFloat(product?.price) > 0 &&
      moment(FREE_KIT_DATE, DATE_FORMAT).isAfter(
        moment(enrolmentDate, DATE_FORMAT)
      ) &&
      selectedClass?.service?.service === "Weekly Fun Soccer") ||
    (!selectedClass.kitMandatory &&
      paymentOption === "full" &&
      product &&
      parseFloat(product?.price) > 0 &&
      moment(FREE_KIT_DATE, DATE_FORMAT).isAfter(
        moment(enrolmentDate, DATE_FORMAT)
      ) &&
      selectedClass?.service?.service === "Childcare Fun Soccer")
  ) {
    orderAmount =
      orderAmount >= parseFloat(product?.price)
        ? orderAmount - parseFloat(product?.price)
        : orderAmount;
  }

  totalAmountToPay = isFinite(totalAmountToPay) ? totalAmountToPay : 0;

  //Adding Order Amount
  if (isFinite(orderAmount) && parseFloat(orderAmount) > 0) {
    totalAmountToPay = totalAmountToPay + orderAmount;
  }

  let credits = 0;
  //Coupon Discount
  let paid = false;
  console.log("selectedCoupon", selectedCoupon)
  if (
    selectedCoupon?.amount &&
    !moment(selectedCoupon.expiry, "YYYY-MM-DD").isBefore(
      moment(enrolmentDate, DATE_FORMAT)
    )
  ) {
    if (selectedCoupon.type === "flat") {
      if (parseFloat(selectedCoupon.amount) === totalAmountToPay) {
        paid = false;
      } else if (parseFloat(selectedCoupon.amount) < totalAmountToPay) {
        paid = true;
      }

      if (parseFloat(selectedCoupon.amount) <= totalAmountToPay) {
        totalAmountToPay =
          totalAmountToPay > 0
            ? totalAmountToPay - parseFloat(selectedCoupon.amount)
            : totalAmountToPay;
      } else {
        credits = parseFloat(selectedCoupon.amount) - totalAmountToPay;

        totalAmountToPay =
          totalAmountToPay > 0
            ? `0($${credits} Credits Remaining)`
            : totalAmountToPay;
        paid = false;
      }
    } else if (selectedCoupon.type === "percentage") {
      console.log("~~~~~~~~~totalAmountToPay", totalAmountToPay)

      totalAmountToPay =
        totalAmountToPay > 0
          ? totalAmountToPay * (1 - parseFloat(selectedCoupon.amount) / 100)
          : totalAmountToPay;
      console.log("totalAmountToPay", totalAmountToPay)

      totalAmountToPay = parseFloat(totalAmountToPay).toFixed(2);
      paid = true;
    }
  }

  if (totalAmountToPay > 0) {
    paid = true;
  }

  if (totalAmountToPay <= 0) {
    paid = false;
  }

  let classTotalAmount = isFinite(orderAmount)
    ? totalAmountToPay - orderAmount
    : totalAmountToPay;

  classTotalAmount = parseFloat(classTotalAmount) >= 0 ? classTotalAmount : 0;

  if (selectedClass?.admin_fee > 0) {
    totalAmountToPay = totalAmountToPay + selectedClass?.admin_fee;
  }
  console.log("totalAmountToPay line 748", totalAmountToPay)

  return {
    classAmountTotal: isFinite(totalMatchDayAmount)
      ? classTotalAmount - totalMatchDayAmount
      : classTotalAmount,
    classPrice,
    totalAmountToPay: totalAmountToPay,
    studentsData: applyAdditionalChildDiscount,
    totalOrderAmount: isFinite(orderAmount) ? orderAmount : 0,
    paid,
    totalMatchDayAmount,
    adminFee: selectedClass?.admin_fee * values?.childs?.length,
  };
};

export const renderLessonVenueName = ({ lesson, selectedClass }) => {
  let lessonName = "";
  if (lesson?.venue) {
    lessonName = lesson?.date + " - " + lesson?.venue?.name;
  } else if (lesson?.location) {
    lessonName = lesson?.date + " - " + lesson?.location?.name;
  } else if (selectedClass?.venue) {
    lessonName = lesson?.date + " - " + selectedClass?.venue?.name;
  } else if (selectedClass?.location) {
    lessonName = lesson?.date + " - " + selectedClass?.location?.name;
  }

  return lessonName;
};

export const renderCapacityCheckText = (cls) => {
  let capacityCheckMessage = "";
  let booking;

  if (cls.activeCancelPendingEnrolments && cls.activeCancelPendingEnrolments != undefined) {
    booking = (cls?.activeCancelPendingEnrolments?.length / cls?.capacity) * 100;
  } else {
    booking = (cls?.students?.length / cls?.capacity) * 100;
  }

  if (cls?.capacity) {
    if (booking >= 0 && booking <= 59) {
      capacityCheckMessage = "Places still available to book.";
    } else if (booking === 60) {
      capacityCheckMessage = "Places still available. Book soon.";
    } else if (booking >= 61 && booking <= 90) {
      capacityCheckMessage = "High demand. Book soon.";
    } else if (booking > 90 && booking <= 100) {
      capacityCheckMessage = "Nearly full. Book quickly.";
    } else {
      capacityCheckMessage = "";
    }
  } else {
    capacityCheckMessage = "Places still available to book.";
  }

  return capacityCheckMessage;
};


export const cardAndBankChargesHelper = (totalPrice, charges) => {
  let price = charges / 100 * totalPrice
  price = Number(price).toFixed(2);
  price = price == "NaN" ? 0 : price;
  return price;
};

export const cardAndBankChargesWithTotalHelper = (totalPrice, charges) => {

  let price = Number(charges) / 100 * Number(totalPrice)
  price = Number(price).toFixed(2);
  let newPrice = Number(totalPrice) + Number(price)
  newPrice = isNaN(newPrice) ? 0 : newPrice;
  return Number(newPrice).toFixed(2);
};